import React, {useContext} from "react";
import {ModalContext} from "../../../contexts/modal/ModalContext";
import {LoadingContext} from "../../../contexts/loading/LoadingContext";
import {AuthContext} from "../../../contexts/auth/AuthContext";
import {useIntl} from "react-intl";
import {Button, Col, Form, Row} from "react-bootstrap";
import MaxiIcon from "../../Maxiicon/MaxiIcon";
import messages from "../../../i18n/messages";
import {LEARN_CHARACTER_TYPE} from "../../../configuration/configurations";
import {addNewChar} from "../../../utils/LearningUtil";

const LearnAdmin = () => {
    const intl = useIntl();
    const [, setModalContext] = useContext(ModalContext);
    const [, setLoadingContext] = useContext(LoadingContext);
    const [authContext,] = useContext(AuthContext);
    const [charType, setCharType] = React.useState(LEARN_CHARACTER_TYPE.CHINESE);
    const [newChar, setNewChar] = React.useState('');

    const onSubmitNewCharClick = async () => {
        try {
            if (newChar.trim().length === 0) {
                setModalContext({
                    isShow: true,
                    title: intl.formatMessage(messages.errMsgTitle),
                    content: intl.formatMessage(messages.errMsgNewCharEmptyError),
                    onConfirm: () => {},
                });
                return;
            }

            setLoadingContext({
                isLoading: true,
                loadingText: '',
            });
            // add new character
            const response = await addNewChar(charType, newChar, authContext.token);
            if (!response.ok) {
                setModalContext({
                    isShow: true,
                    title: intl.formatMessage(messages.errMsgTitle),
                    content: intl.formatMessage(messages.errMsgServerError),
                    onConfirm: () => {},
                });
            }
        } catch (error) {
            console.log(error);
        } finally {
            setNewChar('');
            setLoadingContext({
                isLoading: false,
                loadingText: '',
            });
        }
    }

    const onCharTypeChange = (event) => {
        setCharType(event.target.value);
    }

    const onNewCharInputChange = (event) => {
        setNewChar(event.target.value.trim());
    }

    const getInputMaxLength = () => {
        switch (charType) {
            case LEARN_CHARACTER_TYPE.CHINESE:
                return 2;
            case LEARN_CHARACTER_TYPE.ALPHABET_DE:
                return 1;
            case LEARN_CHARACTER_TYPE.NUMBER:
                return 3;
            default:
                return 2;
        }
    }

    return (
        <>
            {authContext.isAdmin &&
            <>
                <Row>
                    <Col xs={12} sm={12} md={{span: 4, offset: 4}}>
                        <Form>
                            <Form.Group>
                                <Form.Label>{intl.formatMessage(messages.charType)}</Form.Label>
                                <Form.Select aria-label="Default select example" value={charType} onChange={onCharTypeChange}>
                                    <option value={LEARN_CHARACTER_TYPE.CHINESE}>{intl.formatMessage(messages.chineseCharacterLabel)}</option>
                                    <option value={LEARN_CHARACTER_TYPE.ALPHABET_DE}>{intl.formatMessage(messages.alphabetLabel)}</option>
                                    <option value={LEARN_CHARACTER_TYPE.NUMBER}>{intl.formatMessage(messages.numberLabel)}</option>
                                </Form.Select>
                            </Form.Group>
                            <br/>
                            <Form.Group className={'msg-input-label'}>
                                <Form.Label>{intl.formatMessage(messages.characterOrNumber)}</Form.Label>
                                <Form.Control type="text" maxLength={getInputMaxLength()} value={newChar} onChange={onNewCharInputChange}/>
                            </Form.Group>
                        </Form>
                    </Col>
                </Row>
                <br/>
                <Row>
                    <Col xs={12} sm={12} md={{span: 4, offset: 4}}>
                        <Button variant={"success"} onClick={onSubmitNewCharClick}>
                            <MaxiIcon iconName={'faCirclePlus'}/>&nbsp;{intl.formatMessage(messages.submitButtonLabel)}
                        </Button>
                    </Col>
                </Row>
            </>
            }
        </>
    );
}

export default LearnAdmin;